import React from 'react';
// import { Link } from 'react-router-dom';
import './NavigationSidebar.scss';
import NavigationSidebarItem from './NavigationSidebarItem';
import NavigationSidebarItemGroup from './NavigationSidebarItemGroup';

type NavigationSidebarProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  items: NavigationSidebarItem[];
  className?: string;
  itemsClassName?: string;
  hideSubItemIcons?: boolean;
  openSubItemsByDefault?: boolean;
};

export type NavigationSidebarItem = {
  category?: string;
  title: string;
  route: string;
  icon?: string;
  external?: boolean;
  subItems?: NavigationSidebarItem[];
};

const NavigationSidebar = ({ items, header, footer, className, itemsClassName, hideSubItemIcons = false, openSubItemsByDefault = false }: NavigationSidebarProps) => {
  return (
    <>
      {header && header}
      <nav className={`navigation-sidebar ${className}`}>
        <ul className={`navigation-sidebar__items ${itemsClassName}`}>
          {items.map((item) => (
            <li key={item.route}>
              {item.subItems ? (
                <NavigationSidebarItemGroup label={item.title} route={item.route} icon={item.icon || ''} items={item.subItems} hideSubItemIcons={hideSubItemIcons} openByDefault={openSubItemsByDefault} />
              ) : (
                <NavigationSidebarItem to={item.route} label={item.title} icon={item.icon} external={item.external} />
              )}
            </li>
          ))}
        </ul>
      </nav>
      {footer && footer}
    </>
  );
};

export default NavigationSidebar;
